<template>
  <w-settings-content-template :default-side="true" side-width="300px">
    <el-row slot="title">
      비즈니스
    </el-row>
    <div slot="sideContent">
      <w-search-field class="mr-b10" @search="searchKeword"/>
      <el-tree ref="bizTree" :data="treeData" :props="defaultProps" :node-key="defaultProps.treeKey" :expand-on-click-node="false" highlight-current default-expand-all :filter-node-method="filterNode" @node-click="onClickNode">
        <span class="el-tree-node__label" slot-scope="{ node, data }">
          <span :class="getTypeClass(data)">{{ data.label }}</span>
        </span>
      </el-tree>
    </div>
    <component slot="content" :is="currentView" :current-node="selectedNode" @reloadTree="loadData"></component>
  </w-settings-content-template>
</template>

<script>
import { isEmpty } from 'lodash';
import { defaultProps } from '@/constants/tree';
import msgUtil from '@/utils/message';
import ApmSettingAPI from '@/api/settings/apm/apm-setting';
import WSettingsContentTemplate from '@/components/template/SettingsContentTemplate';
import WSearchField from '@/components/form/SearchField';
import WDomainSettingView from '../components/view/DomainSettingView';
import WBizSettingView from './BizSettingView';
import WKeyTrsSettingView from './KeyTrsSettingView';

export default {
  name: 'WKeyTrsMainView',
  components: {
    WSettingsContentTemplate,
    WSearchField,
    WDomainSettingView,
    WBizSettingView,
    WKeyTrsSettingView,
  },
  props: {
    activeView: String,
  },
  data() {
    return {
      defaultProps,
      title: '비즈니스',
      treeData: [],
      selectedNode: {},
      currentView: 'WDomainSettingView',
    };
  },
  watch: {
    activeView: {
      immediate: true,
      handler(activeViewName) {
        if (activeViewName === this.$options.name) {
          this.loadData();
        }
      },
    },
    selectedNode(node) {
      if (node.type === 'root') {
        this.currentView = WDomainSettingView.name;
      } else if (node.type === 'domain') {
        this.currentView = WBizSettingView.name;
      } else if (node.type === 'group') {
        this.currentView = WKeyTrsSettingView.name;
      } else {
        this.currentView = null;
      }
    },
  },
  methods: {
    /**
     * 노드가 아닐 경우 group class 적용
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     * @author jda
     */
    getTypeClass(data) {
      return data.type === 'domain' ? 'group' : null;
    },
    /**
     * 키 트랜잭션 트리 데이터를 조회한다.
     * @return {[type]} [description]
     * @author jda
     */
    loadData() {
      ApmSettingAPI.getGroupTreeByType({ currentTreeType: 'keyTrs', includeRoot: true, isGroupTree: true })
        .then((response) => {
          if (response.data.success) {
            const treeData = response.data.children;
            this.treeData = treeData;
            this.$store.dispatch('setTreeData', treeData);

            this.$nextTick(() => {
              const bizTree = this.$refs.bizTree;
              let treeKey;
              if (isEmpty(this.selectedNode)) {
                treeKey = treeData[0].treeKey;
                this.selectedNode = bizTree.getNode(treeKey).data;
              }
              treeKey = this.selectedNode.treeKey;
              bizTree.setCurrentKey(treeKey);
            });
          } else {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '비즈니스 트리', false));
          }
        }).catch(() => {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '비즈니스 트리', false));
        });
    },
    /**
     * 선택된 트리 노드 데이터 바인딩
     * @param  {[type]} data [description]
     * @param  {[type]} node [description]
     * @return {[type]}      [description]
     * @author jda
     */
    onClickNode(data) {
      this.selectedNode = data;
    },
    /**
     * 트리 검색
     * @param  {[type]} keyword [description]
     * @return {[type]}         [description]
     * @author jda
     */
    searchKeword(keyword) {
      this.$refs.bizTree.filter(keyword);
    },
    /**
     * 트리 필터 메소드
     * @param  {[type]} value [description]
     * @param  {[type]} data  [description]
     * @return {[type]}       [description]
     * @author jda
     */
    filterNode(value, data) {
      if (!value) return true;

      const keyword = value.toLowerCase();
      return data.label.toLowerCase().indexOf(keyword) !== -1;
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/assets/scss/_variable.scss';

.el-tree-node {
  .el-tree-node__label {
    .group {
      font-family: 'Lato', 'Noto Sans KR', sans-serif;
      font-size: 14px;
      font-weight: 500;
      line-height: 22px !important;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/views/settings/apm/ConfigSettings/key-transaction/index.vue